import React, { useEffect, useRef, useState } from "react";
import { Briefcase, Search } from "react-feather";
import Input from "../../components/input/Input";
import Dropdown from "../../components/input/Dropdown";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import SearchDropdown from "../../components/input/SearchDropdown";
import Button from "../../components/input/Button";
import { searchEmployeeModification } from "../../api/employeeModificationApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import EmployeeDateChange from "../../components/support/employee modification/EmployeeDateChange";
import { useSelector } from "react-redux";
import { FORMS, MODULES } from "../../const";
import {
  ActiveCellStyle,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";

const EmployeeModification = () => {
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const [fullName, setFullName] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [empNic, setEmpNic] = useState("");
  const [category, setCategory] = useState("");
  const [stakeholder, setStakeholder] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setTodate] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [searchFieldRest, setSearchFieldRest] = useState(false);
  const [stakeholderType, setStakeholderType] = useState("");
  const [searchSubmitting, setSearchSubmitting] = useState(false);
  const [results, setResults] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Support]);
  const employeeDateUpdatePermission =
    auth[FORMS.EMPLOYEE_MODIFICATION.UPDATE_DATE.form]?.FIELD?.VIEW;

  const modalRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    (async () => {
      const {
        emp_category: categoryOpt,
        active: activeOpt,
        vehicle_status: statusOpt,
      } = await getBulkDropdownData([
        { key: "emp_category" },
        { key: "active" },
        { key: "vehicle_status" },
      ]);
      setCategoryOptions(categoryOpt);
      setActiveOptions(activeOpt);
      setStatusOptions(statusOpt);
    })();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setSearchSubmitting(true);
    setIsSearchLoading(true);
    setSearchClicked(true);

    const searchRequest = {
      fullName: fullName ? fullName : "-2",
      empCode: empCode ? empCode : "-2",
      empNic: empNic ? empNic : "-2",
      category: category ? category : -2,
      stakeholder: stakeholder ? stakeholder : -2,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      status: status ? status : -2,
      active: active ? active : -2,
    };

    try {
      const response = await searchEmployeeModification(searchRequest);
      setResults(response);
      setIsSearchLoading(false);
    } catch (error) {
      console.log("Error get the search", error);
      setIsSearchLoading(false);
    } finally {
      setSearchSubmitting(false);
    }
  };

  const handleDateChange = () => {
    setIsModalOpen(true);
    modalRef.current?.showModal();
  };

  const handleModalSuccess = () => {
    setIsModalOpen(false);
    setSelectedRows([]);
    setSelectedIds([]);
    if (gridRef.current) {
      const selectedNodes = gridRef.current.getSelectedNodes();
      selectedNodes.forEach((node) => {
        node.setSelected(false);
      });
    }
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const getActionMenOptions = () => {
    const actionMenu = [];

    if (employeeDateUpdatePermission) {
      actionMenu.push({
        key: 1,
        text: "Change Expire Dates",
        value: 1,
      });
    }
    return actionMenu;
  };

  const actionsMenuChange = (data) => {
    switch (data.value) {
      case 1:
        handleDateChange();
        break;
    }
  };

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
    if (selectedData.length > 0) {
      setSelectedIds(selectedData.map((item) => item.empId));
      console.log("Selected IDs:", selectedIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleRest = () => {
    setFullName("");
    setEmpCode("");
    setEmpNic("");
    setCategory("");
    setStakeholder("");
    setFromDate("");
    setTodate("");
    setStatus("");
    setActive("");
    setSearchFieldRest(true);
    setTimeout(() => {
      setSearchFieldRest(false);
    }, 100);
    setSearchClicked(false);
  };

  return (
    <div>
      <div
        className="ui attached tabular"
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <div className="ui tabular menu top attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => setTab(1)}
          >
            <span>
              <Briefcase size={15} style={{ marginRight: "5px" }} />
            </span>
            Employee Search
          </div>
        </div>
      </div>

      <div
        className="ui botton attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion ? "active" : ""}`}
            onClick={() => setActiveAccordion(!activeAccordion)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${activeAccordion ? "active" : ""}`}>
            <form className="ui form">
              <div className="four fields">
                <Input
                  label="Full Name"
                  name="fullName"
                  value={fullName}
                  placeholder="Full Name"
                  onChange={(e) => setFullName(e.target.value)}
                />
                <Input
                  label="Employee Code"
                  placeholder="Employee Code"
                  value={empCode}
                  onChange={(e) => setEmpCode(e.target.value)}
                />
                <Input
                  label="NIC."
                  placeholder="1234567890v,154789562V,..."
                  value={empNic}
                  onChange={(e) => setEmpNic(e.target.value)}
                />
                <Dropdown
                  label="Category"
                  options={categoryOptions}
                  value={category}
                  placeholder="Category"
                  onChange={(e, { value }) => {
                    setCategory(value);
                    if (value) {
                      setStakeholderType(
                        value === 3 || value === 4 ? "Customer" : "Transporter",
                      );
                    } else {
                      setStakeholderType(false);
                    }
                  }}
                />
              </div>
              <div className="four fields">
                <SearchDropdown
                  label="Stakeholder"
                  reset={searchFieldRest}
                  setReset={setSearchFieldRest}
                  clearable={true}
                  onClear={() => setStakeholder("")}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: stakeholderType,
                  }}
                  onResultSelect={(data) => setStakeholder(data)}
                  disabled={!category}
                />
                <Input
                  label="From Date"
                  type="date"
                  placeholder="From Date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <Input
                  label="To Date"
                  type="date"
                  placeholder="To Date"
                  value={toDate}
                  onChange={(e) => setTodate(e.target.value)}
                />
                <Dropdown
                  label="Status"
                  options={statusOptions}
                  placeholder="Status"
                  value={status}
                  onChange={(e, { value }) => setStatus(value)}
                />
              </div>
              <div className="four fields">
                <Dropdown
                  label="Active"
                  options={activeOptions}
                  placeholder="Active"
                  value={active}
                  onChange={(e, { value }) => setActive(value)}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button template="search" onClick={handleSearch} />
                  <Button template="searchReset" onClick={handleRest} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {searchClicked && (
        <>
          {isSearchLoading ? (
            <LoadingSpinner />
          ) : (
            <Grid
              ref={gridRef}
              content={results}
              heading="Employees"
              multiRowSelection={true}
              onSelectionChanged={handleSelectionChanged}
              handleActionMenuChange={actionsMenuChange}
              showActionMenu={selectedRows.length > 0 && employeeDateUpdatePermission}
              actionMenuOptions={getActionMenOptions()}
              config={[
                {
                  headerName: "Employee Code",
                  field: "employeeCode",
                  checkboxSelection: true,
                  headerCheckboxSelection: true,
                },
                { headerName: "Employee Name", field: "employeeName" },
                { headerName: "NIC", field: "empNic" },
                { headerName: "Stakeholder", field: "stakeholderName" },
                { headerName: "Category", field: "categoryName" },
                {
                  headerName: "Status",
                  field: "statusName",
                  cellRenderer: StatusCellStyle,
                },
                {
                  headerName: "Active",
                  field: "activeName",
                  cellRenderer: ActiveCellStyle,
                },
              ]}
            />
          )}
        </>
      )}

      <Modal
        ref={modalRef}
        isOpen={isModalOpen}
        onClose={handleModalSuccess}
        onCloseCleanUp={handleModalSuccess}
        minWidth={"60vw"}
      >
        <EmployeeDateChange
          key={isModalOpen ? "open" : "closed"}
          selectedIds={selectedIds}
          onSuccess={handleModalSuccess}
          onClose={handleModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default EmployeeModification;
